module.exports = __webpack_public_path__ + "img/rule-en.9e53c138.png";